module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_2.5cd07097.png";